module.exports = __webpack_public_path__ + "static/media/finanziamento.0fcb2507.jpg";